<template>
  <div id="list">
    <div class="background-image-container" :style="{ backgroundImage: backgroundImage}"></div>
    <div class="width-constraint">
      <div class="content-box list-header">
        <div class="top">
          <span class="text-muted">Oprettet af Discover Lasso</span>
          <span class="text-muted text-semibold text-black">Omhandler {{list.label}}</span>
        </div>
        <div class="bottom">
          <img src="~@/assets/img/logo-square.png" />
          <h1 class="t-name">{{list.title}}</h1>
          <p class="text-muted">
            <span v-html="list.description"></span>
          </p>
        </div>
      </div>
      <news-feed :news="news.news" :loading="loadingNews" feed-type="list" :is-query-related="true"></news-feed>
    </div>
  </div>
</template>

<script>
import { store } from '@/assets/js/store.js'
import NewsFeed from '@/components/NewsFeed'
import Lists from '@/assets/js/lists.js'
import { EventBus, Story } from '@/assets/js/helpers.js'
import Directives from '@/assets/js/directives.js'
import windowSize from '@/window-size'
export default {
  name: 'list',
  data () {
    return {
      loadingNews: false
    }
  },
  computed: {
    list: function () {
      return Lists[this.$route.params.listName]
    },
    news: function () {
      return this.$store.state.lists[this.$route.params.listName] || { news: { items: [] } }
    },
    backgroundImage: function () {
      // return require('img/discover/' + Lists[this.$route.params.listName].imageId.replace('.jpg', '_1600.jpg'))
      var img = Lists[this.$route.params.listName].imageId
      switch (windowSize.size) {
        case 'xxs': img = img.replace('.jpg', '_768.jpg'); break
        case 'xs': img = img.replace('.jpg', '_768.jpg'); break
        case 'sm': img = img.replace('.jpg', '_992.jpg'); break
        case 'md': img = img.replace('.jpg', '_1200.jpg'); break
        case 'lg': img = img.replace('.jpg', '_1600.jpg'); break
      }
      return 'url(' + img + ')'
      // return 'url(' + require('img/discover/' + img) + ')'
    }
  },
  methods: {
    loadNews: function (more, count = 11) {
      this.loadingNews = true
      store.dispatch('loadList', { listName: this.$route.params.listName, more, count }).then(() => {
        this.loadingNews = false
      })
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('loadList', { listName: to.params.listName, more: false, count: 11 }).then(() => {
      EventBus.$emit('frontLoaded')
      next()
    })
  },
  beforeRouteUpdate: function (to, from, next) {
    store.dispatch('loadList', { listName: to.params.listName, more: false, count: 21 }).then(() => {
      next()
    })
  },
  mounted: function () {
    var that = this
    EventBus.$on('loadNews', function () { that.loadNews(true, 21) })
  },
  destroyed: function () {
    EventBus.$off('loadNews')
  },
  components: {
    'news-feed': NewsFeed
  },
  directives: {
    'event-on-visible': Directives.eventOnVisible
  }
}
</script>

<style lang="less" scoped>
  #list {
    .width-constraint {
      margin: 0 auto;
    }

    .background-image-container {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      height: 400px;
      max-height: 600px;
      width: 100%;
    }

    .list-header {
      position: relative;
      z-index: 1;
      padding-top: 30px;
      .top {
        display: flex;
        justify-content: space-between;
        padding: 0 30px 15px 30px;
      }
      .bottom {
        display: flex;
        flex-direction: row;
        // align-items: center;
        margin-bottom: 30px;
        padding: 0 30px 30px 30px;
        img {
          height: 30px;
          margin-right: 25px;
          margin-top: 5px;
        }
        h1 {
          font-size: 35px;
          margin: 0;
          flex: 1;
        }
        p {
          margin: 0;
          margin-left: 100px;
          text-align: right;
        }
      }
    }
  }

  #app.xxs, #app.xs {
    #list {
      .background-image-container {
        height: 250px;
      }
      padding-top: 135px;

      .list-header {
        .top {
          display: none;
        }

        .top, .bottom {
          flex-direction: column;
          text-align: center;
        }

        .bottom {
          img {
            display: none;
          }
          h1 {
            margin-bottom: 15px;
          }
          p {
            margin: 0;
            text-align: center;
          }
        }
      }
    }
  }

  #app.sm #list, #app.md #list {
    .background-image-container {
      height: 250px;
    }
    padding-top: 135px;
  }

  #app.lg {
    #list {
      padding-top: 285px;
      .list-header {
        p {
          max-width: 50%;
        }
      }
    }
  }

</style>
